import {KTCard} from 'src/_metronic/helpers'
import {ListViewProvider} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import { DeletedTransactionsListHeader } from './components/header/DeletedTransactionsListHeader'
import { DeletedTransactionsTable } from './table/DeletedTransactionsTable'

const DeletedTransactionsList = () => {
  return (
    <>
      <KTCard>
        <DeletedTransactionsListHeader />
        <DeletedTransactionsTable />
      </KTCard>
    </>
  )
}

const DeletedTransactionsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <DeletedTransactionsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {DeletedTransactionsListWrapper}
